module.exports = __webpack_public_path__ + "img/DSC_1083.09d00928.jpg";